/* tslint:disable */
/* eslint-disable */
/**
 * Kiwi Framework
 * Kiwi API description
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChunkQueueRequest
 */
export interface ChunkQueueRequest {
    /**
     * 
     * @type {string}
     * @memberof ChunkQueueRequest
     */
    jobId: string;
}

/**
 * Check if a given object implements the ChunkQueueRequest interface.
 */
export function instanceOfChunkQueueRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "jobId" in value;

    return isInstance;
}

export function ChunkQueueRequestFromJSON(json: any): ChunkQueueRequest {
    return ChunkQueueRequestFromJSONTyped(json, false);
}

export function ChunkQueueRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChunkQueueRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jobId': json['jobId'],
    };
}

export function ChunkQueueRequestToJSON(value?: ChunkQueueRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'jobId': value.jobId,
    };
}

